export enum ViewabilityEnvironment {
  Web = 'web',
  InApp = 'in-app'
}
